var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimsMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    rx: 56,
    fill: "#E8F5FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 50H52C50.9 50 50 49.1 50 48C50 46.9 50.9 46 52 46H60C61.1 46 62 46.9 62 48C62 49.1 61.1 50 60 50Z",
    fill: "#1E69D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 56H52C50.9 56 50 55.1 50 54C50 52.9 50.9 52 52 52H60C61.1 52 62 52.9 62 54C62 55.1 61.1 56 60 56Z",
    fill: "#1E69D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39L68 36L65 39L62 36L59 39L56 36L53 39L50 36L47 39L44 36V64H40C38.9 64 38 64.9 38 66V70C38 73.32 40.68 76 44 76H68C71.32 76 74 73.32 74 70V36L71 39ZM62 72H44C42.9 72 42 71.1 42 70V68H48H56H62V72ZM70 70C70 71.1 69.1 72 68 72C66.9 72 66 71.1 66 70V66C66 64.9 65.1 64 64 64H60H56H48V42H70V70Z",
    fill: "#1E69D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50C67.1046 50 68 49.1046 68 48C68 46.8954 67.1046 46 66 46C64.8954 46 64 46.8954 64 48C64 49.1046 64.8954 50 66 50Z",
    fill: "#1E69D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66 56C67.1046 56 68 55.1046 68 54C68 52.8954 67.1046 52 66 52C64.8954 52 64 52.8954 64 54C64 55.1046 64.8954 56 66 56Z",
    fill: "#1E69D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimsMessageIcon);
export default __webpack_public_path__ + "static/media/claims_message_icon.775a4f53c431f93c31c63b5c1d53c48e.svg";
export { ForwardRef as ReactComponent };